import { useEffect, useState } from 'react'
import _ from 'lodash'
import axios from 'axios'
import BreadCrumb from '../../components/BreadCrumb'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import PageTitleInstaller from '../../components/PageTitleInstaller'
import Card from '../../components/Card'
import SiteFormView from '../../components/SiteFormView'
import { ENPHASE_INSTALLER } from '../../components/Header/constants'
import { getIsInstaller, getSessionToken } from '../../utils/helper'
import urlStrings from '../../utils/urlStrings'
import Loader from '../../utils/loader'
import history from '../../routes/history'
import { useStyles } from './styles'
import CustomStepper from '../../components/CustomStepper'
import { Box } from '@material-ui/core'
import { applicationStatus } from './constant'
import { applicationService } from '../../Services/ApplicationService'

const SiteStatusInstaller = (props) => {
  const classes = useStyles()
  const site_id = _.get(props.match.params, 'siteid', '')
  const [site, setSite] = useState(null)
  const [selected, setSelected] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (_.isEmpty(getSessionToken())) {
      history.push('/')
    } else if (getIsInstaller() === 'false') history.push('/customersupport')
    setLoading(true)
    applicationService.getApplicationBySiteId(site_id)
      .then((data) => {
        setSite(data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [site_id])
  console.log(site)
  const sequences = ['Applications', `Site ID: ${site_id}`]
  return (
    <div className={classes.layout}>

      <Loader loading={loading}></Loader>
      <Header
        isSignedIn={true}
        role={ENPHASE_INSTALLER}
        setLoading={setLoading}
        selected={selected}
        setSelected={setSelected}
      ></Header>
      <BreadCrumb sequences={sequences}></BreadCrumb>
      <PageTitleInstaller
        heading={`Application for Site ID: ${site_id}`}
        hasEditApplicationButton={site?.status === 'rejected'}
        status={site && site.status}
        site={site}
      ></PageTitleInstaller>
      <Box className={classes.stepperContainer}>
        <CustomStepper currentStep={site && applicationStatus[site.status]} status={site && site.status} />
      </Box>
      <Card
        className={classes.cardWrapper}
        children={<SiteFormView site={site}></SiteFormView>}
      />
      <Footer></Footer>
    </div>
  )
}
export default SiteStatusInstaller
